import { render } from "./breadcrumb-doctor.vue?vue&type=template&id=aad96474"
import script from "./breadcrumb-doctor.vue?vue&type=script&lang=js"
export * from "./breadcrumb-doctor.vue?vue&type=script&lang=js"

import "./breadcrumb-doctor.vue?vue&type=style&index=0&id=aad96474&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__